import React from "react"
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'

export const InputField = ({ id, type, label, name, autoComplete, disabled, value, onChange, error, isLoading=false }) => {
 if (isLoading) return <SkeletonInput label={label} />

  return (
    <div className="col-span-full">
      <InputLabel htmlFor={id} error={error} className="block text-sm font-medium text-gray-700">
        {label}
      </InputLabel>
      <div className="mt-1">
        <input
          key={id}
          type={type}
          id={id}
          placeholder={label}
          name={name}
          onChange={onChange}
          autoComplete={autoComplete}
          disabled={disabled}
          value={value}
          className={`shadow-xs block w-full rounded-md border-gray-300 focus:ring-0 focus:border-blue-400 sm:text-sm disabled:cursor-not-allowed placeholder-gray-400 ${error ? 'ring-1 ring-red-400' : '' }`}
        />
      </div>
    </div>
  );
};

export const SkeletonInput = ({label}) => {
  return (
    <div className="col-span-full">
      <div className="flex">
        <span className="animate-pulse text-sm font-medium bg-gray-200 text-gray-200">{label}</span>
      </div>
      <div className="mt-2 animate-pulse">
        <div className="block w-full rounded-md bg-gray-200 px-3 py-2 sm:text-sm border-gray-200 border">&nbsp;</div>
      </div>
    </div>
  )
}

export const InputLabel = ({htmlFor, children, error}) => {
  return (
    <label htmlFor={htmlFor} className="flex text-sm font-medium text-gray-700">
      {children}{error ? <ExclamationCircleIcon className="h-5 w-5 ml-2 text-red-500"/> : ''}
    </label>
  )
}